import { render, staticRenderFns } from "./selective-process-table.component.vue?vue&type=template&id=d7c5592a&scoped=true&"
import script from "./selective-process-table.component.vue?vue&type=script&lang=ts&"
export * from "./selective-process-table.component.vue?vue&type=script&lang=ts&"
import style0 from "./selective-process-table.component.vue?vue&type=style&index=0&id=d7c5592a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c5592a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
